module.exports = __webpack_public_path__ + "static/media/58.1d43b12f.jpg";